module.exports = __webpack_public_path__ + "static/media/dischargeGray.1ea48859.png";